export enum EPrizeType {
    MAIN = "jackpot",
    MONTHLY = "month",
    WEEKLY = "week",
    DAILY = "day",
}
